module.exports = __webpack_public_path__ + "static/thanks.154b8c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thanks.png
// module id = 23
// module chunks = 168707334958949